import { IconNames } from 'sprite/types';

import { PerformerLinksFragment } from 'types/api/dato-operations.types';

const SOCIAL_ICON_LOOKUP: Record<keyof PerformerLinksFragment, IconNames> = {
  anghami: 'Anghami',
  mixcloud: 'Mixcloud',
  soundcloud: 'LogoSoundcloud',
  spotify: 'LogoSpotify',
  youtube: 'LogoYoutube',
};

type SocialLink = {
  key: string;
  href: string;
  iconName: IconNames;
};

export const mapSoundPlayerLinks = (links?: PerformerLinksFragment) => {
  if (!links) return [];

  return Object.entries(links).reduce<Array<SocialLink>>(
    (memo, [key, href]) => {
      if (!!href) {
        memo.push({
          key,
          href,
          iconName: SOCIAL_ICON_LOOKUP[key as keyof PerformerLinksFragment],
        });
      }
      return memo;
    },
    [],
  );
};
